<template>
  <keep-alive>
    <top-navbar :currentRoute="$route"></top-navbar>
  </keep-alive>
  <section class="container-content">
    <div class="card-user notification-card">
      <!-- <span>юридическое лицо</span> -->
      <h1>{{ partner }}</h1> 
      <br>
      <!-- <span>договор</span>
      <p>№ 27326327 от 13.12.2023</p>
      <br>
      <span>срок действия</span>
      <p>до 13.12.2023</p>
      <br> -->
      <span>адрес электронной почты</span>
      <p>{{ email }}</p>
      <br>
      <span>дата последней авторизации</span>
      <p>{{ lastAuth }}</p>
      
      <button class="btn btn-default" type="submit" @click="exit()">
        Завершить сессию
      </button>
    </div>
  </section>
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
export default {
  name: 'ProfilePage',
  components: {
    TopNavbar
  },
  data() {
    return {
      partner: "",
      lastAuth: "24.04.2024",
      email: "email@gmail.com"
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    exit() {
      this.$router.push({
        path: '/login'
      });

      localStorage.removeItem('token')
      localStorage.removeItem('auth')
      localStorage.removeItem('company')
      localStorage.removeItem('email')
      localStorage.removeItem('lastAuth')
      localStorage.removeItem('partner')
      localStorage.removeItem('userID')
      localStorage.removeItem('vuex')
      localStorage.removeItem('temp')
      localStorage.removeItem('orderFields_')
    },
    getInfo() {
      if(localStorage.getItem('partner') != undefined && localStorage.getItem('partner') != '') {
        // this.partner = localStorage.getItem('partner')
        const raw = localStorage.getItem('partner') || '';
        try { 
          this.partner = JSON.parse(raw); 
        } catch (_) {
          // если обычная строка, то на всякий случай уберём экранирование
          this.partner = raw.replace(/\\"/g, '"').replace(/^"(.*)"$/, '$1');
        }
      }
      if(localStorage.getItem('lastAuth') != undefined && localStorage.getItem('lastAuth') != '') {
        this.lastAuth = localStorage.getItem('lastAuth')
      }
      if(localStorage.getItem('email') != undefined && localStorage.getItem('email') != '') {
        this.email = localStorage.getItem('email')
      }
    }
  }
}
</script>
